import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

/** First consultation is free for every customer — this tells us if theirs is still unused. */
export const useFreeConsult = (email = "") => {
    const { data } = useQuery({
        queryKey: ["free-consult-offer", email],
        queryFn: async () => {
            const token = localStorage.getItem("rhm_customer_token");
            const { data: res } = await axios.get(`${BASE}/api/consult/free-offer`, {
                params: email ? { email } : {},
                withCredentials: true,
                headers: token ? { Authorization: `Bearer ${token}` } : {},
            });
            return res;
        },
        staleTime: 60000,
        retry: false,
    });
    return { eligible: data?.eligible !== false, used: !!data?.used, loaded: !!data };
};
